/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Military(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.001 0.667969C12.4762 0.667969 14.8503 1.65123 16.6006 3.40137C18.3508 5.15162 19.3349 7.52577 19.335 10.001C19.3349 10.1979 19.2762 10.3804 19.1777 10.5352C19.1387 10.5968 19.0944 10.6556 19.042 10.708L10.708 19.041C10.3175 19.4314 9.68444 19.4315 9.29395 19.041L0.960938 10.708C0.902936 10.65 0.854098 10.5848 0.8125 10.5156C0.788123 10.4752 0.765626 10.4335 0.74707 10.3896C0.695617 10.2678 0.667969 10.1358 0.667969 10.001C0.667969 9.93829 0.669524 9.8761 0.672852 9.81445C0.720924 7.40676 1.69521 5.10766 3.40137 3.40137C5.15158 1.65115 7.52581 0.668107 10.001 0.667969ZM10.001 8.50098C8.87542 8.50119 8.18228 9.20439 8.09375 9.85938L10.001 15.3066L11.9072 9.8584C11.818 9.20365 11.1261 8.50098 10.001 8.50098ZM4.37598 8.50098C3.51688 8.50119 2.89798 9.02407 2.7207 9.63965L7.60938 14.5283L6.14062 10.3311C6.10354 10.225 6.08496 10.1133 6.08496 10.001C6.08496 9.24538 5.39396 8.50098 4.37598 8.50098ZM15.626 8.50098C14.602 8.50123 13.918 9.2436 13.918 10.001C13.918 10.1133 13.8994 10.225 13.8623 10.3311L12.3926 14.5273L17.2803 9.64062C17.1017 9.02566 16.4801 8.50098 15.626 8.50098ZM10.001 2.66797C8.05624 2.66811 6.19057 3.44029 4.81543 4.81543C4.28606 5.34485 3.84685 5.94733 3.50586 6.59863C3.78699 6.53443 4.07877 6.50102 4.37598 6.50098C5.42909 6.50098 6.41888 6.92849 7.11035 7.63477C7.85202 6.92029 8.9115 6.50111 10.001 6.50098C11.0897 6.50098 12.148 6.92034 12.8896 7.63379C13.5794 6.92818 14.5681 6.50112 15.626 6.50098C15.9231 6.50098 16.2154 6.53489 16.4971 6.59961C16.1558 5.94789 15.7162 5.34514 15.1865 4.81543C13.8113 3.44037 11.9457 2.66797 10.001 2.66797Z"
        fill="#35424F"
      />
    </svg>
  )
}

Military.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Military
